export default "__VITE_ASSET__oe6LNmgn__"